import { BaseApiResponseModel } from "api/baseApiResponseModel/BaseApiResponseModel";
import { getMessage } from "utils/helpersInTs/helpersInTs";
import { defaultPathConfigRepository } from "../pathConfig/PathConfigRepository";
import {
  MenuConfigModel,
  SidebarMenuConfigModel,
} from "./model/SidebarMenuConfigModel";

export interface IConfigRepository {
  getSidebarMenu(
    role: boolean,
    language: string
  ): Promise<BaseApiResponseModel<SidebarMenuConfigModel>>;
}

export interface IMenuService {
  name: string;
  path: string;
  componentName: string;
  icon: string;
  subMenu?: MenuConfigModel[] | [];
}

export class SidebarMenuConfigRepository implements IConfigRepository {
  getSidebarMenu(
    role: boolean,
    language: string
  ): Promise<BaseApiResponseModel<SidebarMenuConfigModel>> {
    return new Promise(async (resolve, reject) => {
      let menuConfig: MenuConfigModel[] = [];
      try {
        let admin = [];
        let user = [];
        const res = await defaultPathConfigRepository?.configDetail(
          "neci_cms_navigations"
        );
        if (res) {
          let data = JSON.parse(res?.data?.config as string);
          if (language === "en") {
            admin = data?.engAdmin;
            user = data?.engUser;
          } else {
            admin = data?.admin;
            user = data?.user;
          }

          switch (role) {
            case true:
              menuConfig = admin?.map((item: IMenuService) => {
                return new MenuConfigModel(
                  item?.name,
                  item?.path,
                  item?.componentName,
                  item?.icon,
                  item?.subMenu?.map((sub: any) => {
                    return new MenuConfigModel(
                      sub?.name,
                      sub?.path,
                      sub?.componentName,
                      sub?.icon
                    );
                  })
                );
              });
              break;
            case false:
              menuConfig = user?.map((item: IMenuService) => {
                return new MenuConfigModel(
                  item?.name,
                  item?.path,
                  item?.componentName,
                  item?.icon,
                  item?.subMenu?.map((sub: any) => {
                    return new MenuConfigModel(
                      sub?.name,
                      sub?.path,
                      sub?.componentName,
                      sub?.icon
                    );
                  })
                );
              });
              break;
            default:
              return undefined;
          }
        }
      } catch (error) {
        console.log(error);
      }
      resolve(
        new BaseApiResponseModel<SidebarMenuConfigModel>(
          new SidebarMenuConfigModel(menuConfig),
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined
        )
      );
    });
  }
}

export default new SidebarMenuConfigRepository();
